// src/components/DashboardFooter.jsx
export default function DashboardFooter() {
  return (
    <footer className="bg-green-700 text-white text-center py-3 mt-auto">
      &copy; {new Date().getFullYear()} Aarogyam Homoeopathic Clinic. All rights reserved.
    </footer>
  );
}
